<template>
  <div v-if="isVisible" class="modal-overlay" @click.self="closeModal">
    <div class="inactivity-modal">
      <div class="modal-header">
        <h3> Внимание</h3>
      </div>
      
      <div class="modal-body">
        <p class="warning-text">Вы бездействуете 2 минуты</p>
        <p class="countdown-text">
          Этот заказ закроется через 
          <span class="countdown">{{ countdown }}</span> 
          секунд
        </p>
      </div>
      
      <div class="modal-footer">
        <button @click="continueWork" class="btn btn-primary">
          Закончить дела
        </button>
        <button @click="closeOrder" class="btn btn-secondary">
          Закрыть заказ
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'InactivityModal',
  props: {
    isVisible: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      countdown: 10,
      countdownTimer: null
    };
  },
  watch: {
    isVisible(newVal) {
      if (newVal) {
        this.startCountdown();
      } else {
        this.stopCountdown();
      }
    }
  },
  methods: {
    startCountdown() {
      this.countdown = 10;
      this.countdownTimer = setInterval(() => {
        this.countdown--;
        if (this.countdown <= 0) {
          this.closeOrder();
        }
      }, 1000);
    },
    
    stopCountdown() {
      if (this.countdownTimer) {
        clearInterval(this.countdownTimer);
        this.countdownTimer = null;
      }
    },
    
    continueWork() {
      this.$emit('continue-work');
      this.closeModal();
    },
    
    closeOrder() {
      this.$emit('close-order');
      this.closeModal();
    },
    
    closeModal() {
      this.stopCountdown();
      this.$emit('close');
    }
  },
  
  beforeDestroy() {
    this.stopCountdown();
  }
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.inactivity-modal {
  background: white;
  border-radius: 8px;
  padding: 24px;
  max-width: 400px;
  width: 90%;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
  animation: modalAppear 0.3s ease-out;
}

@keyframes modalAppear {
  from {
    opacity: 0;
    transform: scale(0.9);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}

.modal-header {
  text-align: center;
  margin-bottom: 20px;
}

.modal-header h3 {
  margin: 0;
  color: #ff6b6b;
  font-size: 20px;
  font-weight: 600;
}

.modal-body {
  text-align: center;
  margin-bottom: 24px;
}

.warning-text {
  font-size: 16px;
  color: #333;
  margin-bottom: 12px;
  font-weight: 500;
}

.countdown-text {
  font-size: 14px;
  color: #666;
  margin: 0;
}

.countdown {
  font-weight: bold;
  color: #ff6b6b;
  font-size: 16px;
}

.modal-footer {
  display: flex;
  gap: 12px;
  justify-content: center;
}

.btn {
  padding: 10px 20px;
  border: none;
  border-radius: 4px;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.btn-primary {
  background-color: #007bff;
  color: white;
}

.btn-primary:hover {
  background-color: #0056b3;
}

.btn-secondary {
  background-color: #6c757d;
  color: white;
}

.btn-secondary:hover {
  background-color: #545b62;
}
</style> 